import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Dynamisch Social Media Meta-Tags und Viewport setzen
const updateMetaTags = () => {
  // Meta Tags für Social Media Vorschau (Discord, WhatsApp, etc.)
  const metaTags = [
    { property: 'og:title', content: 'Duocode - Lerne Programmieren spielerisch' },
    { property: 'og:description', content: 'Lerne Programmieren spielerisch und kostenlos. Kurse für Python, JavaScript, HTML und Kotlin.' },
    { property: 'og:type', content: 'website' },
    { name: 'theme-color', content: '#179CF0' }, // Wichtig für Discord Farbe
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: 'Duocode - Lerne Programmieren spielerisch' },
    { name: 'twitter:description', content: 'Lerne Programmieren spielerisch und kostenlos. Kurse für Python, JavaScript, HTML und Kotlin.' }
  ];

  metaTags.forEach(tag => {
    let element;
    if (tag.property) {
      element = document.querySelector(`meta[property="${tag.property}"]`);
    } else if (tag.name) {
      element = document.querySelector(`meta[name="${tag.name}"]`);
    }

    if (!element) {
      element = document.createElement('meta');
      if (tag.property) element.setAttribute('property', tag.property);
      if (tag.name) element.setAttribute('name', tag.name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', tag.content);
  });

  // Viewport Meta-Tag optimieren, damit Toolbar über Tastatur erscheint (interactive-widget)
  let viewport = document.querySelector("meta[name='viewport']");
  if (viewport) {
    const content = viewport.getAttribute("content");
    if (content && !content.includes("interactive-widget")) {
      viewport.setAttribute("content", content + ", interactive-widget=resizes-content");
    }
  }
};

updateMetaTags();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Direkte Service Worker Registrierung (Zuverlässiger für PWABuilder)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker erfolgreich registriert mit Scope: ', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker Registrierung fehlgeschlagen: ', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
